import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-level"]
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "io-sidebar-group__children"
}

import {
  ref,
  computed,
  watch,
  onBeforeUpdate,
} from 'vue';
import { useStore } from 'vuex';
import Expansion from '@/components/Expansion.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarGroup',
  props: {
  item: {
    type: Object,
    required: true,
  },
  level: {
    type: Number,
    required: false,
    default: () => 1,
  },
  index: {
    type: Number,
    required: false,
    default: () => 1,
  },
},
  emits: ['open'],
  setup(__props, { emit: __emit }) {

library.add(faChevronDown);

const props = __props;
const emit = __emit;

const store = useStore();
const isOpen = ref(false);
const hasChildren = computed(() => Object.values(props.item.children || {}).length > 0);
const sidebarGroups = ref([]);

const toggleSidebar = () => {
  store.dispatch('sidebar/toggle', 'sidebar');
};

const openOrMove = (move: { (): void }) => {
  if (!hasChildren.value || (hasChildren.value && isOpen.value)) {
    toggleSidebar();
    move();
  } else {
    isOpen.value = true;
  }
};

watch(() => props.item, () => {
  isOpen.value = props.item.active;
}, { deep: true });

onBeforeUpdate(() => {
  sidebarGroups.value = [];
});

const closeChildren = (keepInx: number | null = null) => {
  sidebarGroups.value.forEach((sidebarGroup, groupInx) => {
    const sg = sidebarGroup as { close: () => void };
    if (groupInx !== keepInx) {
      sg.close();
    }
  });
};

watch(() => isOpen.value, () => {
  if (isOpen.value) {
    emit('open');
  }
});

return (_ctx: any,_cache: any) => {
  const _component_IoRouterLink = _resolveComponent("IoRouterLink")!
  const _component_SidebarGroup = _resolveComponent("SidebarGroup", true)!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["io-sidebar-group", {
         'open': isOpen.value,
         'has-children': hasChildren.value,
         'active': __props.item.active,
      }]),
    "data-level": __props.level
  }, [
    _createVNode(_component_IoRouterLink, {
      "link-url": __props.item.url,
      "link-target": __props.item.target,
      "link-title": __props.item.titleAttr,
      "custom-handler": openOrMove
    }, {
      default: _withCtx(() => [
        (__props.item.icon !== null)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "sidebar__icon",
              style: _normalizeStyle(`background-image: url('${__props.item.icon}')`)
            }, null, 4))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: "sidebar__label",
          innerHTML: __props.item.title
        }, null, 8, _hoisted_2),
        (hasChildren.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createVNode(_unref(FontAwesomeIcon), { icon: "fa-regular fa-chevron-down" })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["link-url", "link-target", "link-title"]),
    (hasChildren.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(Expansion, {
            class: "io-sidebar-group__children-wrapper",
            expanded: isOpen.value
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, (child, childInx) => {
                return (_openBlock(), _createBlock(_component_SidebarGroup, {
                  key: `sg-${__props.level}-${__props.index}-${childInx}`,
                  item: child,
                  level: __props.level + 1,
                  ref_for: true,
                  ref: el => { if (el) sidebarGroups.value[childInx] = el },
                  onOpen: ($event: any) => (closeChildren(childInx))
                }, null, 8, ["item", "level", "onOpen"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["expanded"])
        ]))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})